import de from '@/internationalization/trans/chefs/de/de.json';
export default {
  trans: de,
};
